import { User, UserInterface } from './user.model';

export interface UserDetailedInterface {
  user?: UserInterface;
  discomfort?: string;
  discomfortValue?: number;
  risk?: string;
  riskValue?: number;
  riskInvariant?: number;
  numAssessments?: number;
}

export class UserDetailed implements UserDetailedInterface {
  public user?: UserInterface;
  public discomfort?: string;
  public discomfortValue?: number;
  public risk?: string;
  public riskValue?: number;
  public riskInvariant?: number;
  public numAssessments?: number;

  constructor({
    user = undefined,
    discomfort = undefined,
    discomfortValue = undefined,
    risk = undefined,
    riskValue = undefined,
    riskInvariant = undefined,
    numAssessments = undefined,
  }: UserDetailedInterface) {
    this.user = user ? new User(user) : undefined;
    this.discomfort = discomfort;
    this.discomfortValue = discomfortValue;
    this.risk = risk;
    this.riskValue = riskValue;
    this.riskInvariant = riskInvariant;
    this.numAssessments = numAssessments;
  }
}
